import {Component, Input, OnInit} from '@angular/core';
import {NgClass} from "@angular/common";

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    imports: [
        NgClass
    ]
})
export class SpinnerComponent implements OnInit {
  @Input() showContrast = false;
  @Input() extendedClass: string = '';

  constructor() {
  }

  ngOnInit(): void {
  }

}
